<div>
  <main-pg #mainpg [sideOnTop]="true">
    <flex-row header>
      <img src="assets/Home.svg" class="icon" (click)="home()" left>
      <div center>
        <a class="btn btn-info" [routerLink]="'mainedit'">Main Editor</a>
        <a class="btn btn-info" [routerLink]="'dldocstest01'">Docs</a>
        <a class="btn btn-info" [routerLink]="'dlsd001'">Scene Edit</a>
      </div>
      <div right>
        <div (click)="login()">Login</div>
      </div>
    </flex-row>
    <div side>
      <div class="sidebar">
        <h6 class="closebutton" (click)="closeSide()">🗙</h6>
        <h4>All Sections:</h4>

        @for(menuItem of menuItems;track menuItem.key){
        <h5 class="section_text" (click)="routeTo(menuItem.key);mainpg.switchSide()">{{menuItem.value}}</h5>
        }

      </div>
    </div>
    <div contest><!-- class="hero-background-2" -->
      <div class="editor_main_container">
        <!--<dream-loom-scene-demo-001></dream-loom-scene-demo-001>-->
        <!--<main-editor></main-editor>-->
        <!--<docs-tests></docs-tests>-->
        <!--<dl-css-template-part></dl-css-template-part>-- >
        <!-- <dl-css-template></dl-css-template>-->
        <router-outlet></router-outlet>
      </div>
    </div>
    <flex-row footer>
      <div left>
        <img src="assets/Menu.svg" class="icon" (click)="mainpg.switchSide()" left>
        <!--<button class="btn btn-success" (click)="mainpg.openSide()">Side</button>
          <button class="btn btn-danger" (click)="mainpg.closeSide()">No Side</button>-->
      </div>
      <h3 center>
        <img [src]="screenAsset" class="icon" (click)="fullscreen()">
      </h3>
      <img src="assets/Gear.svg" class="icon" (click)="openSettings()" right>
      <!--<h3 right> 
          <button class="btn btn-danger" (click)="openSettings()">Settings</button>
        </h3>-->
    </flex-row>
  </main-pg>
</div>

<div class="dl-app-glass-overlay-container">
  @for(layer of glassLayers;track layer.name){
  <dl-app-glass-layer [layerName]="layer.name" [blocking]="layer.blocking"></dl-app-glass-layer>
  }
</div>